/**
 * Interim shims over the unified host query API. Lighthouses are hosts; every hook here delegates
 * to the host equivalent with {@link LIGHTHOUSE_FILTER} merged in, so all reads and writes share the
 * single `hostQueryKeys` cache namespace. Each shim is deleted together with its last caller when
 * the lighthouse screens merge into the hosts screens.
 */
import {
  hostsCountQueryOptions,
  makeHostsQueryOptions,
  useSuspenseHostQuery,
  useSuspenseHostsCount,
} from '#api/hosts.queries.ts';
import { LIGHTHOUSE_FILTER, type GetHostsFilter } from '#api/hosts.ts';

/** Interim shim — use {@link useSuspenseHostQuery} — lighthouse details are host details. */
export function useSuspenseLighthouseQuery(lighthouseId: string) {
  return useSuspenseHostQuery(lighthouseId);
}

/** Interim shim — use {@link makeHostsQueryOptions} with {@link LIGHTHOUSE_FILTER}. */
export const makeLighthousesQueryOptions = (cursor?: string, pageSize?: number, filter?: GetHostsFilter) =>
  makeHostsQueryOptions(cursor, pageSize, { ...filter, ...LIGHTHOUSE_FILTER });

/** Interim shim — use {@link hostsCountQueryOptions} with {@link LIGHTHOUSE_FILTER}. */
export const lighthouseCountQueryOptions = (filter: GetHostsFilter = {}) =>
  hostsCountQueryOptions({ ...filter, ...LIGHTHOUSE_FILTER });

/** Interim shim — use {@link useSuspenseHostsCount} with {@link LIGHTHOUSE_FILTER}. */
export function useSuspenseLighthousesCount() {
  return useSuspenseHostsCount(LIGHTHOUSE_FILTER);
}
